<script setup>
import useAddNewCourse from "@/scripts/Courses/AddNewCourse";
import SearchableSelectComponent from "@/components/SearchableSelectComponent.vue";

const {
  name,
  regionSlug,
  contract_devices,
  type,
  product_type,
  loading,
  productsList,
  typeList,
  regionsList,
  isFormValid,
  save,
} = useAddNewCourse();
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">ADD NEW COURSE</h3>
    </div>
    <div class="card-body">
      <table class="table table-bordered table-hover">
        <tbody>
          <tr>
            <td>
              <input
                type="text"
                class="form-control"
                placeholder="Name"
                v-model="name"
              />
            </td>
            <td>
              <SearchableSelectComponent
                v-model="regionSlug"
                :options="regionsList"
                label="slug"
                track-by="id"
                placeholder="Region"
                return-value="slug"
              />
            </td>
            <td>
              <input
                type="number"
                class="form-control"
                placeholder="Contract Devices"
                v-model="contract_devices"
              />
            </td>
            <td>
              <SearchableSelectComponent
                v-model="type"
                :options="typeList"
                label="name"
                track-by="slug"
                placeholder="Course Type"
                return-value="slug"
              />
            </td>
            <td>
              <SearchableSelectComponent
                v-model="product_type"
                :options="productsList"
                label="name"
                track-by="id"
                placeholder="Package Type"
                return-value="id"
              />
            </td>
            <td>
              <button
                @click="save"
                class="btn btn-primary fixed-width-button"
                :disabled="loading || !isFormValid"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">SAVE</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
.fixed-width-button {
  width: 70px;
}
</style>
